export default {
  api: {
    baseUrl: 'https://api.admin.makna.ai',
    chatUrl: 'https://api.admin.makna.ai',
    backOfficeUrl: 'https://api.admin.makna.ai/api',
    leadsUrl: 'https://api.x.wappin.app/leads',
  },
};
